<template>
  <form class="cp-schema-editor" ref="schemaForm">
    <div class="cp-schema-lg" v-for="(group, groupIdx) in getGroups" :key="groupIdx">
      <div class="cp-schema-lg-header">
        <span class="cp-schema-lg-header-label">{{ getLocalizedMuiValue(group.name) }}</span>
      </div>
      <div class="cp-schema-lg-body">
        <div class="cp-schema-li" v-for="(item, itemIdx) in group.items" :key="itemIdx">
          <AdvCartProductCustomizationEditorItem :item="item" />
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import localizationMuiMixin from '../mixins/localizationMuiMixin'
import AdvCartProductCustomizationEditorItem from './AdvCartProductCustomizationEditorItem.vue'

export default {
  name: 'AdvCartProductCustomizationEditor',
  mixins: [
    localizationMuiMixin
  ],
  components: {
    AdvCartProductCustomizationEditorItem
  },
  props: {
    schema: {
      type: Object,
      required: true
    }
  },
  computed: {
    getSchema () {
      if (!this.schema || !('schema' in this.schema)) {
        return {
          groups: []
        }
      }

      return this.schema.schema
    },
    getGroups () {
      return this.getSchema.groups
    }
  },
  methods: {
    validate () {
      return this.$refs.schemaForm.reportValidity()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "AdvCartProductCustomizationEditorStyling.scss";
</style>
